import { emptySplitApi as api } from "./emptyApi"

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    audienceClassificationControllerGetAll: build.query<
      AudienceClassificationControllerGetAllApiResponse,
      AudienceClassificationControllerGetAllApiArg
    >({
      query: () => ({ url: `/audience-classification` }),
      providesTags: ["AudienceClassifications"],
    }),
    audienceClassificationControllerReplaceAll: build.mutation<
      AudienceClassificationControllerReplaceAllApiResponse,
      AudienceClassificationControllerReplaceAllApiArg
    >({
      query: arg => ({
        url: `/audience-classification`,
        method: "PUT",
        body: arg,
      }),
      invalidatesTags: ["AudienceClassifications"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as generatedApi }

export type AudienceClassification = "EXISTING" | "ENGAGED"

export type AudienceClassificationDto = {
  id: string
  companyId: string
  audienceRef: string
  classification: AudienceClassification
}

export type SaveAudienceClassificationsDto = {
  classifications: {
    audienceRef: string
    classification: AudienceClassification
  }[]
}

export type AudienceClassificationControllerGetAllApiResponse =
  AudienceClassificationDto[]
export type AudienceClassificationControllerGetAllApiArg = void

export type AudienceClassificationControllerReplaceAllApiResponse =
  AudienceClassificationDto[]
export type AudienceClassificationControllerReplaceAllApiArg =
  SaveAudienceClassificationsDto

export const {
  useAudienceClassificationControllerGetAllQuery,
  useAudienceClassificationControllerReplaceAllMutation,
} = injectedRtkApi
